import { useState } from "react";
import AdminSibilla from "./AdminSibilla";
import AdminPiacentine from "./AdminPiacentine";
import AdminRune from "./AdminRune";
import AdminDeck from "./AdminDeck";
import { ALTRO_TOOLS } from "../../lib/methods";

// Sezione "Metodi": raccoglie le basi di interpretazione interne dei mazzi
// (carte, significati, abbinamenti) usate dalle consultazioni. Mai visibili ai clienti.
const CUSTOM = { piacentine: AdminPiacentine, rune: AdminRune };

const SECTIONS = [
  { value: "sibilla", label: "Sibille", Component: AdminSibilla },
  ...ALTRO_TOOLS.filter((t) => t.deck).map((t) => ({
    value: t.deck,
    label: t.title,
    Component: CUSTOM[t.deck] || (() => <AdminDeck deck={t.deck} title={t.title} />),
  })),
];

export default function AdminMetodi() {
  const [sub, setSub] = useState("sibilla");
  const active = SECTIONS.find((s) => s.value === sub) || SECTIONS[0];
  const Active = active.Component;
  return (
    <div data-testid="admin-metodi-section">
      <h2 className="font-display text-2xl text-amber-100 mb-2">Metodi</h2>
      <p className="text-xs text-purple-300/60 mb-6">
        Basi di interpretazione interne dei mazzi: carte, significati e abbinamenti usati dalle consultazioni.
      </p>
      <div className="flex flex-wrap gap-2 mb-8" data-testid="admin-metodi-nav">
        {SECTIONS.map((s) => (
          <button
            key={s.value}
            onClick={() => setSub(s.value)}
            data-testid={`admin-metodi-tab-${s.value}`}
            className={`text-xs rounded-full border px-4 py-1.5 transition-colors ${
              sub === s.value
                ? "border-amber-500/60 bg-amber-500/10 text-amber-200"
                : "border-[#4a2175] text-purple-200/70 hover:border-amber-500/30"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
